/**
 * LLM 后台的**外壳**文案（S1 建）：区块标题 + 非 admin 的无权卡片。
 * 各能力片的文案在自己的文件里（`providers.js` / 后续 `models.js` / `modes.js` / …）。
 */

export const en = {
  title: 'LLM operations',
  forbidden: {
    title: 'Admin access only',
    description:
      'The LLM console changes what every game request costs and which upstream it hits, so it is limited to the admin role. Ask an administrator if you need access.',
  },
}

export const zh = {
  title: 'LLM 运营',
  forbidden: {
    title: '仅限管理员',
    description:
      'LLM 后台能改动每一次游戏请求走哪个上游、花多少钱，只对 admin 角色开放。需要权限请找管理员。',
  },
}
